app
  .controller("VerticalContentListController", [
    "$scope",
    "getSiteDetails",
    function ($scope, getSiteDetails) {
      $scope.bgColor = $scope.payload.bgColor;
      $scope.textColor = $scope.payload.textColor;

      if ($scope.payload) {
        getSiteDetails
          .getPlaylistContent($scope.payload.playlistID)
          .then((result) => {
            $scope.elementContent = result.content[0];
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
  ])
  .directive("verticalContentList", function () {
    return {
      restrict: "AE",
      transclude: true,
      scope: true,
      templateUrl: "template/elements/contentList.html",
    };
  });
